// extracted by mini-css-extract-plugin
module.exports = {"negativeBtn":"negativeBtn__IQOlV"};